import config from '@strangeanimals/common-vue-components/src/helpers/config';
const processEnv = process.env;

// OAuth credentials now handled server-side via /api/auth/client-token endpoint
// See src/services/authService.js for implementation
// DO NOT add VUE_APP_API_CLIENT_ID or VUE_APP_API_CLIENT_SECRET here

config.appName = 'payments';
config.tokenExpirationHours = 12;
config.vueAppEnvironment = processEnv.VUE_APP_ENVIRONMENT;
config.vueAppVersion = processEnv.VUE_APP_VERSION;
config.useCloudSentry = processEnv.VUE_APP_USE_CLOUD_SENTRY === "true";

// Enable Azure SSO using backend server-side flow
// The AzureOauthSignIn component has been updated to use server-side authentication
// instead of client-side MSAL library for better security
config.enableSSO = true;

export default config;
